import * as React from 'react';

function ActionButtonIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.3327 9.83366L18.136 13.2187L15.6585 13.927L17.4293 16.9945L15.986 17.8278L14.2152 14.7612L12.3627 16.5528L12.3327 9.83366ZM10.666 4.00033H12.3327V5.66699H16.4993C16.7204 5.66699 16.9323 5.75479 17.0886 5.91107C17.2449 6.06735 17.3327 6.27931 17.3327 6.50033V9.83366H15.666V7.33366H7.33268V15.667H10.666V17.3337H6.49935C6.27834 17.3337 6.06637 17.2459 5.91009 17.0896C5.75381 16.9333 5.66602 16.7213 5.66602 16.5003V12.3337H3.99935V10.667H5.66602V6.50033C5.66602 6.27931 5.75381 6.06735 5.91009 5.91107C6.06637 5.75479 6.27834 5.66699 6.49935 5.66699H10.666V4.00033ZM2.33268 10.667V12.3337H0.666016V10.667H2.33268ZM2.33268 7.33366V9.00033H0.666016V7.33366H2.33268ZM2.33268 4.00033V5.66699H0.666016V4.00033H2.33268ZM2.33268 0.666992V2.33366H0.666016V0.666992H2.33268ZM5.66602 0.666992V2.33366H3.99935V0.666992H5.66602ZM8.99935 0.666992V2.33366H7.33268V0.666992H8.99935ZM12.3327 0.666992V2.33366H10.666V0.666992H12.3327Z"
        fill="#021337"
      />
    </svg>
  );
}

export default ActionButtonIcon;
